import React from "react";
import { Box } from "@mui/material";
import DashboardSidebar from "./DashboardSidebar";
import DashboardTopbar from "./DashboardTopbar";

export default function DashboardLayout({ title, children }) {
  return (
    <Box sx={{ display: "flex", minHeight: "100vh", background: "#f7f8fa" }}>
      <DashboardSidebar />

      <Box sx={{ flex: 1, minWidth: 0 }}>
        <DashboardTopbar title={title} />

        <Box sx={{ px: 3, py: 3 }}>
          {children}
        </Box>
      </Box>
    </Box>
  );
}
